// SPDX-License-Identifier: Apache-2.0
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customJSON = void 0;
const typedjson_1 = require("../../export/typedjson");
function customJSON(Type) {
    typedjson_1.TypedJSON.mapType(Type, {
        deserializer: (json) => json === null ? json : Type.fromJSON(json),
        serializer: (value) => value === null ? value : Type.toJSON(value),
    });
}
exports.customJSON = customJSON;
//# sourceMappingURL=customjson.js.map